/* ------------------------------------------------------------------------
Copyright (c) 2016, VoiceVibes, Inc

VoiceVibes, Inc - PROPRIETARY/CONFIDENTIAL
All contents of this file are proprietary and confidential. No part of
any of the contents of this file may be disclosed in any manner to
a third party without the prior written consent of VoiceVibes, Inc.
Unauthorized copying of this file, via any medium is strictly prohibited.
----------------------------------------------------------------------------- */

<template>
  <div id="my-library">
    <div class="row">
      <div class="col-sm-3" />
      <div
        class="col-sm-6"
      >
        <div class="recordings-label">
          RECORDINGS
        </div>
        <span class="mylib-filter">
          <span
            :class="{ active: myLibFilter == 'all' }"
            @click.prevent="loadFilter('myLib', 'all')"
          >
            All
          </span>
          |
          <span
            :class="{ active: myLibFilter == 'submitted' }"
            @click.prevent="loadFilter('myLib', 'submitted')"
          >
            Flagged for Review
          </span>
          |
          <span
            :class="{ active: myLibFilter == 'assignment' }"
            @click.prevent="loadFilter('myLib', 'assignment')"
          >
            Assignments
          </span>
          |
          <span
            :class="{ active: myLibFilter == 'private' }"
            @click.prevent="loadFilter('myLib', 'private')"
          >
            Private
          </span>
        </span>
      </div>
      <div class="col-sm-3" />
    </div>
    <table
      v-if="filteredRecordings && filteredRecordings.length"
      :key="myLibKey"
      class="mylib-table newTable table table-bordered"
    >
      <thead>
        <tr>
          <th
            scope="col"
            @click.prevent="sortTable('myLib', 'title')"
          >
            Title
            <svg
              v-if="myLibSort == 'title-d' || myLibSort == 'title-u'"
              class="icon-arrow"
            >
              <use :xlink:href="(myLibSort == 'title-d') ? '/static/svg-symbols.svg#icon-arrow-down' : '/static/svg-symbols.svg#icon-arrow-up'" />
            </svg>
          </th>
          <th
            scope="col"
            @click.prevent="sortTable('myLib', 'group')"
          >
            Group
            <svg
              v-if="myLibSort == 'group-d' || myLibSort == 'group-u'"
              class="icon-arrow"
            >
              <use :xlink:href="(myLibSort == 'group-d') ? '/static/svg-symbols.svg#icon-arrow-down' : '/static/svg-symbols.svg#icon-arrow-up'" />
            </svg>
          </th>
          <th
            scope="col"
            @click.prevent="sortTable('myLib', 'uploaded')"
          >
            Uploaded
            <svg
              v-if="myLibSort == 'uploaded-d' || myLibSort == 'uploaded-u'"
              class="icon-arrow"
            >
              <use :xlink:href="(myLibSort == 'uploaded-d') ? '/static/svg-symbols.svg#icon-arrow-down' : '/static/svg-symbols.svg#icon-arrow-up'" />
            </svg>
          </th>
          <th
            scope="col"
            @click.prevent="sortTable('myLib', 'duration')"
          >
            Duration
            <svg
              v-if="myLibSort == 'duration-d' || myLibSort == 'duration-u'"
              class="icon-arrow"
            >
              <use :xlink:href="(myLibSort == 'duration-d') ? '/static/svg-symbols.svg#icon-arrow-down' : '/static/svg-symbols.svg#icon-arrow-up'" />
            </svg>
          </th>
          <th
            scope="col"
            @click.prevent="sortTable('myLib', 'overall')"
          >
            Vocal Delivery
            <svg
              v-if="myLibSort == 'overall-d' || myLibSort == 'overall-u'"
              class="icon-arrow"
            >
              <use :xlink:href="(myLibSort == 'overall-d') ? '/static/svg-symbols.svg#icon-arrow-down' : '/static/svg-symbols.svg#icon-arrow-up'" />
            </svg>
          </th>
          <th
            scope="col"
            @click.prevent="sortTable('myLib', 'recordingComments')"
          >
            Comments
            <svg
              v-if="myLibSort == 'recordingComments-d' || myLibSort == 'recordingComments-u'"
              class="icon-arrow"
            >
              <use :xlink:href="(myLibSort == 'recordingComments-d') ? '/static/svg-symbols.svg#icon-arrow-down' : '/static/svg-symbols.svg#icon-arrow-up'" />
            </svg>
          </th>
          <th
            v-if="sharingEnabled"
            scope="col"
            @click.prevent="sortTable('myLib', 'rating')"
          >
            Overall Rating
            <svg
              v-if="myLibSort == 'rating-d' || myLibSort == 'rating-u'"
              class="icon-arrow"
            >
              <use :xlink:href="(myLibSort == 'rating-d') ? '/static/svg-symbols.svg#icon-arrow-down' : '/static/svg-symbols.svg#icon-arrow-up'" />
            </svg>
          </th>
          <th
            scope="col"
            @click.prevent="sortTable('myLib', 'coachRating')"
          >
            Overall Coach Rating
            <svg
              v-if="myLibSort == 'coachRating-d' || myLibSort == 'coachRating-u'"
              class="icon-arrow"
            >
              <use :xlink:href="(myLibSort == 'coachRating-d') ? '/static/svg-symbols.svg#icon-arrow-down' : '/static/svg-symbols.svg#icon-arrow-up'" />
            </svg>
          </th>
        </tr>
      </thead>
      <tbody
        v-for="(recording) in filteredRecordings"
        class="recording-tbody"
      >
        <tr
          :key="recording.id"
        >
          <td
            scope="row"
          >
            <router-link
              :to="{ name: 'evaluate-recording', params: { recordingId: recording.recordingId } }"
            >
              {{ recording.title }}
            </router-link>
            <span style="float:right">
              <a
                href="#"
                @click.prevent="remove(recording)"
              >
                <svg class="svgicon icon-trash">
                  <use xlink:href="/static/svg-symbols.svg#icon-trash" />
                </svg>
              </a>
            </span>
          </td>
          <td>
            {{ recording.groupName }}
          </td>
          <td>
            <nobr>{{ recording.createdDate | date }}</nobr>
          </td>
          <td>
            <span v-if="recording.duration">
              {{ recording.duration | time }}
            </span>
            <span v-else>
              -
            </span>
          </td>
          <td>
            {{ (recording.results && recording.results.scores && recording.results.scores.overall) ? recording.results.scores.overall : 'N/A' }}
          </td>
          <td>
            {{ recording.feedbackCount }}
          </td>
          <td
            v-if="sharingEnabled && sharingEnabledForRecording(recording)"
            rowspan="2"
          >
            <star-rating
              inactive-color="#fff"
              :increment="0.5"
              :border-width="1"
              border-color="#cccccc"
              active-color="#EFA042"
              :star-size="15"
              :rating="recording.scoreOverallAvgRating / 2"
              :read-only="true"
              :show-rating="false"
            />
            <small>(avg of {{ recording.numRatingsscoreOverall }} rating{{ recording.numRatingsscoreOverall == 1 ? '' : 's' }})</small>
          </td>
          <td
            v-else-if="sharingEnabled && !sharingEnabledForRecording(recording)"
            rowspan="2"
          >
            N/A
          </td>
          <td rowspan="2">
            <star-rating
              inactive-color="#fff"
              :increment="0.5"
              :border-width="1"
              border-color="#cccccc"
              active-color="#EFA042"
              :star-size="15"
              :rating="recording.scoreOverallAvgRatingCoach / 2"
              :read-only="true"
              :show-rating="false"
            />
            <small>(avg of {{ recording.numCoachRatingsscoreOverall }} rating{{ recording.numRatingsscoreOverall == 1 ? '' : 's' }})</small>
          </td>
        </tr>
        <tr class="active">
          <td colspan="1">
            <div>
              <a
                href="#"
                @click.prevent="rename(recording)"
              >
                Rename
              </a><br>
              <a
                target="_blank"
                :href="recording.wavUrl"
              >
                Download
              </a>
            </div>
          </td>
          <td colspan="2">
            <div
              v-if="recording.assignment"
            >
              Assignment:
              <router-link
                :to="{ name: 'assignment-details',
                       params: {assignmentId: recording.assignment.assignmentId } }"
              >
                <span class="assignmentName">
                  {{ recording.assignment.name }}
                </span>
              </router-link>
            </div>

            <div v-if="recording.failed">
              This recording could not be processed.
            </div>
            <div v-else-if="recording.processing">
              This recording is still processing.
            </div>
            <div v-else-if="!recording.assignment">
              <label
                :for="'ass-sel-' + recording.recordingId"
              >
                Add to Assignment:
              </label>
              <select
                :id="'ass-sel-' + recording.recordingId"
                v-model="activeAssignment"
                class="form-control assignment-select"
                @change="moveRecording(recording)"
              >
                <option
                  selected
                  value=""
                >
                  &nbsp;
                </option>
                <option
                  v-for="ass in filteredAssignments"
                  :value="ass"
                >
                  {{ ass.name }} ({{ ass.groupName }})
                </option>
              </select>
            </div>
          </td>

          <td colspan="3">
            <div v-if="recording.submitted && recording.assignment">
              Flagged for coach review
              on {{ recording.submissionDate | date }},
              <a
                href="#"
                @click.prevent="submit({recordingId: recording.recordingId, submitted: false})"
              >
                Undo
              </a>
              <br>
            </div>
            <div v-if="!recording.submitted && recording.assignment">
              <a
                href="#"
                @click.prevent="submit({recordingId: recording.recordingId, submitted: true})"
              >
                Flag recording for coach review
              </a><br>
            </div>
            <div v-if="recording.feedbackRequested && recording.assignment && sharingEnabledForRecording(recording)">
              Recording shared with entire group on {{ recording.feedbackRequestedDate | date }},
              <a
                href="#"
                @click.prevent="submit({recordingId: recording.recordingId, feedbackRequested: false})"
              >
                Undo
              </a><br>
            </div>
            <div v-if="!recording.feedbackRequested && recording.assignment && sharingEnabledForRecording(recording)">
              <a
                href="#"
                @click.prevent="submit({recordingId: recording.recordingId, feedbackRequested: true})"
              >
                Share recording with entire group
              </a><br>
            </div>
          </td>
        </tr>
        <tr>
          <td
            colspan="8"
            style="padding: 2px;"
          >
            <hr style="margin: 2px;">
          </td>
        </tr>
      </tbody>
    </table>
    <div v-else>
      No recordings found
    </div>
  </div>
</template>

<style lang="less" scoped>
  @import '../../less/bootstrap-vars.less';
  @import '~bootstrap/less/mixins/buttons.less';

  .icon-arrow {
    width: 16px; height: 16px;
    position: relative; top: 3px;
  }
  #my-library {
    margin-top: 20px;
  }
  .assignment-select {
    max-width: 250px;
  }
  .mylib-filter {
    color: @link-color;
    cursor: pointer;
    font-size: 14px;
    font-weight: 600;
  }
  .mylib-filter span.active {
    color: #333;
    cursor: default;
  }
  .recordings-label {
    font-size: 14px;
    font-weight: 400;
  }
  .mylib-table {
    margin-top: 8px;
    th {
      cursor: pointer;
      text-transform: uppercase;
      font-weight: bold;
    }
  }
  .svgicon {
    display: inline-block;
    stroke-width: 0;
    stroke: currentColor;
    fill: currentColor;
  }
  .icon-trash {
    width: 14px; height: 14px;
  }
</style>

<script>
import StarRating from 'vue-star-rating';
import TableMethods from '../specials/TableMethods';

export default {
  components: { StarRating },
  mixins: [ TableMethods ],
  props: [ 'assignments', 'me', 'groups', 'recordings' ],
  data() {
    return {
      activeAssignment: '',
      filters: {},
      assignmentCardKey: 1,
      myLibFilter: 'all',
      myLibKey: 1,
      myLibSort: 'uploaded-u',
    };
  },
  computed: {
    filteredAssignments: {
      cache: false,
      get() {
        return this._.filter(this.assignments, (ass) => {
          return !ass.archived;
        });
      },
    },
    sharingEnabled: {
      cache: false,
      get() {
        let sharingEnabled = false;
        this._.forEach(this.$store.getters.activeGroups, (group) => {
          if (group.speakerPrivacyLevel !== 4) {
            sharingEnabled = true;
          }
        });
        return sharingEnabled;
      }
    },
    filteredRecordings: {
      cache: false,
      get() {
        const filterFuncs = {
          submitted: (r) => {
            return !!r.submitted;
          },
          assignment: (r) => {
            return !!r.assignment;
          },
          all: () => {
            return true;
          },
          private: (r) => {
            return !r.assignment;
          },
        };
        const recs = [];
        this.recordings.forEach((rec) => {
          const filterFunc = filterFuncs[this.myLibFilter] || filterFuncs['all'];
          if (filterFunc(rec)) {
            recs.push(rec);
          }
        });

        return this.sortCollection(recs, this.myLibSort);
      }
    }
  },
  created() {
    ['myLibFilter', 'myLibSort'].forEach((pref) => {
      if (this.preferences && this.preferences[pref]) {
        this[pref] = this.preferences[pref];
      }
    });
  },
  methods: {
    refresh() {
      this.$store.dispatch('getAssignedAssignments').then(() => this.myLibKey++);
    },
    sharingEnabledForRecording(recording) {
      const group = this._.find(this.groups, {groupId: recording.groupId});
      return !!(group && group.speakerPrivacyLevel !== 4);
    },
    moveRecording(recording) {
      if (this.activeAssignment && this.activeAssignment.criteria &&
        this.activeAssignment.criteria.algorithm && recording.results &&
        recording.results.algorithm
      ) {
        const assignmentAlgorithmFeatureName = this.activeAssignment.criteria.algorithm.split('-')[1];
        const recordingAlgorithmFeatureName = recording.results.algorithm.split('-')[1];
        if (assignmentAlgorithmFeatureName !== recordingAlgorithmFeatureName) {
          return this.$store.dispatch('notify', {
            type: 'error',
            subject: 'Unable to Use This Assignment',
            text: 'This assignment only accepts recordings with a single speaker and ' +
              'this recording contains multiple speakers (or vice versa).'
          });
        }
      }
      if (this.activeAssignment && window.confirm(`Are you sure you want to assign this recording to "${this.activeAssignment.name}"? This operation cannot be undone.`)) {
        this.$store.dispatch(
          'addRecordingToAssignment',
          {
            recordingId: recording.recordingId,
            assignmentId: this.activeAssignment.assignmentId,
          }
        ).then(() => this.refresh());
      }
      this.activeAssignment = '';
    },
    remove(recording) {
      if (window.confirm('Delete this recording?')) {
        this.$store.dispatch('delRecording', recording.recordingId).then(() => this.refresh());
      }
    },
    rename(recording) {
      let title = window.prompt('Enter new title for this recording, 50 characters max', recording.title);
      if (!title) return;
      title = title.substr(0, 50);

      this.$store.dispatch(
        'updateRecording',
        {
          recordingId: recording.recordingId,
          title
        }
      ).then(() => this.refresh());
    },
    submit(data) {
      this.$store.dispatch('updateRecording', data).then(() => this.refresh());
    },
  }
};
</script>
